/**
 * 动物性格测试题库
 * 60道题目，每题4个选项（A/B/C/D）
 */
export const animalQuestions = [
  {
    id: 1,
    question: "世界是一片漆黑的森林，你选择成为？",
    options: {
      A: "森林本身，感受每一片树叶。",
      B: "在林间温暖的篝火。",
      C: "隐藏在古树根下深不见底的古井。",
      D: "一阵穿过所有缝隙的风。"
    }
  },
  {
    id: 2,
    question: "你获得了一块记忆橡皮擦，你会擦掉？",
    options: {
      A: "别人对你的所有亏欠，让心灵彻底自由。",
      B: "你最尴尬最羞耻的那个瞬间。",
      C: "一段让你心碎的感情。",
      D: "你犯下的一个无法弥补的错误。"
    }
  },
  {
    id: 3,
    question: `你意外获得了一个"生活BUG"的控制台，但一天只能使用一个指令，你会输入？`,
    options: {
      A: "显示所有事物的隐藏信息",
      B: "召唤会跳舞的羊驼和朋友",
      C: "一键生成绝对舒适区",
      D: "开启主角光环"
    }
  },
  {
    id: 4,
    question: `你更倾向于哪种形式的"永生"？`,
    options: {
      A: "你的思想、作品或传说被永远流传。",
      B: "灵魂转世，不断体验不同的人生。",
      C: "拥有不朽的肉体，看着沧海桑田。",
      D: "化为自然的一部分，如山脉或河流，静观万物。"
    }
  },
  {
    id: 5,
    question: "你内心最深处的恐惧，更接近于？",
    options: {
      A: "被所有人遗忘，仿佛从未存在过。",
      B: "成为一个无聊、平庸、可被替代的人。",
      C: "失去控制，被原始的冲动或混乱所吞噬。",
      D: "被囚禁，无论是物理上还是精神上。"
    }
  },
  {
    id: 6,
    question: "在你的梦境中，哪种场景反复出现？",
    options: {
      A: "在无边无际的水中，时而漂浮，时而下沉。",
      B: "站在悬崖边，俯瞰着壮丽但危险的景色。",
      C: "在一个错综复杂的建筑里奔跑，找不到出口。",
      D: "和一群模糊不清但感觉熟悉的人在一起。"
    }
  },
  {
    id: 7,
    question: "如果你的情绪是一个APP，它最常用的功能是？",
    options: {
      A: `"后台运行"模式，表面风平浪静，CPU已经算到冒烟。`,
      B: `"弹幕分享"功能，把所有内心OS都发到好友群里。`,
      C: `"飞行模式"，一键断开所有连接，谢绝打扰。`,
      D: `"静音模式"，所有通知都只显示角标，不发出任何声音。`
    }
  },
  {
    id: 8,
    question: `你认为"家"的本质是什么？`,
    options: {
      A: "一个可以卸下所有伪装和防备的绝对领域。",
      B: "一群可以无条件接纳你、与你共享喜悦的人。",
      C: "刻在你基因里但那个回不去的故乡。",
      D: "一个精神坐标，无论身在何处，心之所向。"
    }
  },
  {
    id: 9,
    question: "如果必须选择一种感官来放大十倍，你会选？",
    options: {
      A: "听觉，聆听万物的低语和弦外之音。",
      B: "触觉，感受世界的质地和温度。",
      C: "嗅觉，捕捉空气中隐藏的信息和记忆。",
      D: "视觉，看穿表象，洞悉世界的结构。"
    }
  },
  {
    id: 10,
    question: `你如何看待自己的"阴暗面"？`,
    options: {
      A: "是我力量的源泉，需要被理解和掌控。",
      B: "是需要努力克服的弱点。",
      C: "只是我的一部分，没必要大惊小怪。",
      D: "我尽量忽略它，不去想它。"
    }
  },
  {
    id: 11,
    question: `你渴望拥有的"知识"是？`,
    options: {
      A: "看透人心的能力。",
      B: "与自然万物沟通的语言。",
      C: "预测未来的水晶球。",
      D: "解锁宇宙终极规律的钥匙。"
    }
  },
  {
    id: 12,
    question: "死亡来临时，你希望它是何种形态？",
    options: {
      A: "如秋叶般静美地飘落，回归大地。",
      B: "像烟花一样，在最绚烂的瞬间燃烧殆尽。",
      C: "像一场远航，驶向未知的星辰大海。",
      D: "像一场酣睡，在最温暖的梦中不再醒来。"
    }
  },
  {
    id: 13,
    question: `你觉得最"性感"的特质是？`,
    options: {
      A: "饱经沧桑后依旧清澈的眼神。",
      B: "毫不掩饰的原始的生命力。",
      C: "在混乱中依旧保持从容的优雅。",
      D: "专注做某件事时，遗世独立的气质。"
    }
  },
  {
    id: 14,
    question: "如果可以保留一段声音在脑中循环播放，你会选？",
    options: {
      A: "海浪拍打礁石的声音。",
      B: "爱人在耳边的低语。",
      C: "风吹过树林发出的沙沙声。",
      D: "图书馆里安静的翻书声。"
    }
  },
  {
    id: 15,
    question: "你认为自己更像？",
    options: {
      A: "一本需要密码才能打开的古书。",
      B: "一张错综复杂通往宝藏的地图。",
      C: "一个装满了故事和秘密的漂流瓶。",
      D: "一把能打开无数把锁的钥匙。"
    }
  },
  {
    id: 16,
    question: "你是一座岛屿，你希望别人如何登岛？",
    options: {
      A: "我会建立一座坚固的桥，只让我认可的人通过。",
      B: "我的海岸线很长，欢迎任何人停靠，但中心区域不对外开放。",
      C: "我会用迷雾将自己环绕，只有最执着的人才能找到航线。",
      D: "我是一座会移动的岛，只在特定的时候与大陆连接。"
    }
  },
  {
    id: 17,
    question: "在一段关系中，你更像一个？",
    options: {
      A: `给予对方温暖和光亮的"恒星"。`,
      B: `守护对方提供庇护的"港湾"。`,
      C: `引领对方探索未知世界的"向导"。`,
      D: `与对方共舞相互映照的"月亮"。`
    }
  },
  {
    id: 18,
    question: "你的朋友被一只巨大的棉花糖怪兽困住了，你冲过去的第一反应是？",
    options: {
      A: `大喊："别动！让我分析一下它的弱点！"`,
      B: `抄起一个巨大的勺子："朋友挺住！我来帮你吃出一条路！"`,
      C: "陪他静静坐着，然后拿出手机自拍。",
      D: `冷静地指挥："你左边三步，然后跳起来！"`
    }
  },
  {
    id: 19,
    question: `你最不能容忍的"背叛"是？`,
    options: {
      A: "谎言与欺骗。",
      B: "在我最需要的时候转身离开。",
      C: "将我的秘密公之于众。",
      D: "因为懦弱而放弃了我们的共同目标。"
    }
  },
  {
    id: 20,
    question: "当你深爱一个人时，你更倾向于如何表达这份感情？",
    options: {
      A: "默默地为对方做好许多事，但从不主动提起。",
      B: "将对方纳入自己未来的规划，并为其扫清障碍。",
      C: "与对方分享自己最隐秘的精神世界和独特的发现。",
      D: "创造只属于两个人的共同经历和冒险回忆。"
    }
  },
  {
    id: 21,
    question: "你理想的伴侣关系是？",
    options: {
      A: "两棵独立的树，根在地下紧紧相连。",
      B: "一团火焰，相互燃烧，照亮彼此。",
      C: "一个安全的洞穴，共同抵御外界的风雨。",
      D: "两只一同翱翔的鹰，共享同一片天空。"
    }
  },
  {
    id: 22,
    question: "在群体中，你最舒服的位置是？",
    options: {
      A: "在舞台的聚光灯下。",
      B: "在人群边缘，做一个冷静的观察者。",
      C: "在亲密的小圈子里，被温暖和信任包围。",
      D: "在队伍的最前方，带领大家前进。"
    }
  },
  {
    id: 23,
    question: "一个路过的小精灵对你比了个心，你会？",
    options: {
      A: "迅速回一个更酷的手势。",
      B: "开心地比一个更大的心，并附赠一个wink。",
      C: "脸一红，害羞地低下头，但嘴角忍不住上扬。",
      D: "礼貌性地点点头，然后在心里给它的可爱程度打个分。"
    }
  },
  {
    id: 24,
    question: "你认为最浪漫的事是？",
    options: {
      A: "在暴风雨的夜晚，共享一杯热茶。",
      B: "一场说走就走充满未知的冒险。",
      C: "读懂对方一个眼神里所有未说出口的话。",
      D: "共同创造一个只属于你们的、伟大的作品。"
    }
  },
  {
    id: 25,
    question: `你会为什么样的人"拼命"？`,
    options: {
      A: "为那个点燃我灵魂之火的人。",
      B: `为我视为"家人"的整个群体。`,
      C: "为那个无条件信任我、依赖我的人。",
      D: "为值得我追随的拥有共同信念的领袖。"
    }
  },
  {
    id: 26,
    question: `如果爱是一种"馈赠"，你倾向于给予？`,
    options: {
      A: "我最珍贵的收藏。",
      B: "我全部的时间和陪伴。",
      C: "我绝对的忠诚和保护。",
      D: "我对世界的理解和智慧。"
    }
  },
  {
    id: 27,
    question: "当关系结束时，你更像是？",
    options: {
      A: "冰封的火山，外冷内热。",
      B: "改道的河流，奔向新的海洋。",
      C: "被砍掉枝干的树，需要漫长的春天才能发芽。",
      D: "被风吹散的云，形态改变，本质依旧。"
    }
  },
  {
    id: 28,
    question: `在一场化妆舞会上，你觉得哪种装扮最能吸引到"对的人"？`,
    options: {
      A: "戴着乌鸦面具的神秘魔术师。",
      B: "穿着毛茸茸恐龙睡衣的派对核心。",
      C: "假扮成一棵树，安静地待在角落。",
      D: "穿着未来感十足的银色盔甲的神明。"
    }
  },
  {
    id: 29,
    question: `你更希望被如何"记住"？`,
    options: {
      A: "一个有趣的灵魂，一个传奇的故事。",
      B: "一个可靠的朋友，一个温暖的港湾。",
      C: "一个优雅的谜，一段美丽的风景。",
      D: "一个伟大的领袖，一个时代的开创者。"
    }
  },
  {
    id: 30,
    question: "你最想对这个世界说的一句话是？",
    options: {
      A: `"嘘，听。"`,
      B: `"一起玩吧！"`,
      C: `"别怕，有我呢。"`,
      D: `"看好了。"`
    }
  },
  {
    id: 31,
    question: "你在一场必须分出胜负的游戏中，你的策略是？",
    options: {
      A: "精心布局，诱敌深入，最后一击致命。",
      B: "用绝对的力量或气势正面碾压。",
      C: "找到规则的漏洞，用意想不到的方式获胜。",
      D: "结成联盟，牺牲局部，换取最终的集体胜利。"
    }
  },
  {
    id: 32,
    question: `你得到了一份藏宝图，但标注了"极度危险"，你会？`,
    options: {
      A: "独自前往，宝藏和秘密只属于我一人。",
      B: "组建一支精英团队，共享收益与风险。",
      C: "把它卖给更有能力的人，换取眼前的利益。",
      D: "先花大量时间研究地图，分析所有风险，再做决定。"
    }
  },
  {
    id: 33,
    question: "面对挑衅，你的第一反应是？",
    options: {
      A: "一个冷酷的眼神，让对方知难而退。",
      B: "一声响亮的咆哮，宣示我的底线。",
      C: "转身离开，不与傻瓜论长短。",
      D: "微笑，但在心里已经将对方盘算了一遍。"
    }
  },
  {
    id: 34,
    question: `你认为"权力"的本质是？`,
    options: {
      A: "制定规则的资格。",
      B: "保护所爱之人的能力。",
      C: "一种可以交换一切的筹码。",
      D: "一种沉重的责任。"
    }
  },
  {
    id: 35,
    question: `在"真心话大冒险"游戏中，你发现了一个必胜BUG，你会？`,
    options: {
      A: "暗中利用，精准地让某人说出秘密。",
      B: "大声告诉所有人，然后玩点更刺激的！",
      C: "假装不知道，享受提心吊胆的感觉。",
      D: "利用BUG让游戏和平结束，去看电影。"
    }
  },
  {
    id: 36,
    question: "你更擅长？",
    options: {
      A: "在混乱中创造秩序。",
      B: "在秩序中制造惊喜。",
      C: "适应任何环境，像水一样无形。",
      D: "建立一个全新的属于自己的体系。"
    }
  },
  {
    id: 37,
    question: "一个巨大的机遇摆在你面前，但需要你放弃现在的安稳生活，你？",
    options: {
      A: "赌一把，人生需要激情。",
      B: "极度纠结，反复衡量得失。",
      C: "算了，安稳比什么都重要。",
      D: "如果这个机遇符合我的长远规划，就去。"
    }
  },
  {
    id: 38,
    question: `你如何利用你的"优势"？`,
    options: {
      A: "藏起来，作为关键时刻的底牌。",
      B: "大方地展示，吸引同伴或震慑敌人。",
      C: "只在我信任的人面前展现。",
      D: "用它来帮助那些需要帮助的人。"
    }
  },
  {
    id: 39,
    question: `你参加了一场"用梗图battle"的比赛，你的必杀技是？`,
    options: {
      A: "极其冷门但精准吐槽的哲学梗图。",
      B: `能让全场爆笑的"猫猫狗狗"表情包连击。`,
      C: "经典的略带伤感的自嘲梗图。",
      D: `信息量巨大的"史诗级"长图。`
    }
  },
  {
    id: 40,
    question: `你如何看待"捷径"？`,
    options: {
      A: "最聪明的选择。",
      B: "往往是陷阱。",
      C: "如果能走，为什么不走？",
      D: "我更喜欢自己走出一条路。"
    }
  },
  {
    id: 41,
    question: `你的死对头变成了一只只会"咕"的鸽子，落在了你的窗台，你会？`,
    options: {
      A: `教它用摩斯密码"咕"出认罪书。`,
      B: "养得肥肥胖胖，在它面前吃炸鸡。",
      C: "给它搭窝喂米，然后思考自己是不是太善良。",
      D: `把它绑在无人机上放飞，附上纸条："自己飞回来吧，菜鸟。"`
    }
  },
  {
    id: 42,
    question: "你犯错后，最倾向于？",
    options: {
      A: "悄悄弥补，当做什么都没发生过。",
      B: "公开承认，承担后果。",
      C: "自责很久，陷入情绪低谷。",
      D: "分析错误原因，确保不再犯。"
    }
  },
  {
    id: 43,
    question: `你认为最强大的"武器"是？`,
    options: {
      A: "无法被预测的头脑。",
      B: "坚不可摧的意志。",
      C: "令人无法抗拒的魅力。",
      D: "绝对的忠诚。"
    }
  },
  {
    id: 44,
    question: "你丢失了一件非常重要的东西，你会？",
    options: {
      A: "发疯一样地寻找，不惜一切代价。",
      B: "伤心一会儿，然后告诉自己该放下了。",
      C: "相信它总有一天会以某种形式回来。",
      D: "把它当成一次教训，记住这种失去的感觉。"
    }
  },
  {
    id: 45,
    question: "你更愿意成为？",
    options: {
      A: "棋手。",
      B: "棋子（国王或皇后）。",
      C: "旁观的智者。",
      D: "掀翻棋盘的人。"
    }
  },
  {
    id: 46,
    question: `你最向往的"美"是？`,
    options: {
      A: "诞生于毁灭之中的残酷的美。",
      B: "脆弱而转瞬即逝的美。",
      C: "经过时间沉淀后充满智慧的美。",
      D: "雄伟、壮丽、不可征服的美。"
    }
  },
  {
    id: 47,
    question: "如果用一种天气来形容你的内心世界，它会是？",
    options: {
      A: "雷鸣电闪的暴风雨夜。",
      B: "阳光和煦微风拂面的午后。",
      C: "安静飘雪万籁俱寂的冬日。",
      D: "变幻莫测时有彩虹的阵雨天。"
    }
  },
  {
    id: 48,
    question: `你退休后，打算在哪里开一家"只招待有缘人"的奇怪小店？`,
    options: {
      A: `在宇宙空间站里，开一家"失物招领处"。`,
      B: `在移动岛屿上，开一家"能量补给站"。`,
      C: `在图书馆地下室，开一家"懒人沙发店"。`,
      D: `在珠穆朗玛峰顶，开一家"灵魂便利店"。`
    }
  },
  {
    id: 49,
    question: "在艺术作品中，哪种颜色最能代表你的灵魂底色？",
    options: {
      A: "深邃的普鲁士蓝或暗夜黑。",
      B: "明亮的金黄或橙红。",
      C: "温柔的象牙白或浅粉色。",
      D: "高贵的银灰或纯白。"
    }
  },
  {
    id: 50,
    question: `你认为哪种声音最接近"神性"？`,
    options: {
      A: "宇宙深处的脉冲信号。",
      B: "新生儿的第一声啼哭。",
      C: "鲸鱼在深海中的歌唱。",
      D: "无声，绝对的寂静。"
    }
  },
  {
    id: 51,
    question: "如果你的身体必须由一种非生物材料构成，你希望是？",
    options: {
      A: "透明但易碎的玻璃。",
      B: "会发光的钻石。",
      C: "Q弹的果冻。",
      D: "永远保持锋利的精密合金。"
    }
  },
  {
    id: 52,
    question: `你认为什么东西是"无价"的？`,
    options: {
      A: "自由。",
      B: "爱。",
      C: "安全感。",
      D: "时间。"
    }
  },
  {
    id: 53,
    question: `你更愿意与哪种"神"对话？`,
    options: {
      A: "智慧与诡计之神。",
      B: "战争与守护之神。",
      C: "爱与美之神。",
      D: "自然与生命之神。"
    }
  },
  {
    id: 54,
    question: "你发现了一个可以穿梭时空的罗盘，第一次启动时，你希望指针指向哪里？",
    options: {
      A: "指向魔法与巨龙存在的失落古代。",
      B: "指向科技高度发达人人安居乐业的理想未来。",
      C: "指向尚未被探索的充满原始生命力的秘境。",
      D: "指向你童年最无忧无虑的那个夏天。"
    }
  },
  {
    id: 55,
    question: "你更像哪种水？",
    options: {
      A: "能滴水穿石的执着水滴。",
      B: "能容纳百川的辽阔大海。",
      C: "能倒映天空的平静湖泊。",
      D: "能冲毁一切的滔天巨浪。"
    }
  },
  {
    id: 56,
    question: `你认为最酷的"活法"是？`,
    options: {
      A: "成为一个都市传说。",
      B: "成为一部超长待机番剧的主角。",
      C: "成为一个被机器人精心照料的盆栽。",
      D: "成为游戏里的最终BOSS。"
    }
  },
  {
    id: 57,
    question: `你如何看待"命运"？`,
    options: {
      A: "一张可以被改写的草稿。",
      B: "一条虽然曲折但终点已定的河流。",
      C: "一场需要全力以赴的赌局。",
      D: "根本不存在的东西。"
    }
  },
  {
    id: 58,
    question: "如果让你创造一个世界，你最先创造什么？",
    options: {
      A: "规则和逻辑。",
      B: "光和生命。",
      C: "音乐和色彩。",
      D: "秘密和谜题。"
    }
  },
  {
    id: 59,
    question: "在生命的尽头，你回望一生，最让你感到自豪的是？",
    options: {
      A: "我从未背叛过我自己。",
      B: "我用生命守护了我爱的一切。",
      C: "我过得舒适安逸，没留下什么遗憾。",
      D: "我达到了无人企及的高度。"
    }
  },
  {
    id: 60,
    question: "选择你的灵魂图腾：",
    options: {
      A: "螺旋。",
      B: "心形。",
      C: "圆圈。",
      D: "三角。"
    }
  }
];

/**
 * 分数映射表
 * 每题对应的选项分数映射到7个维度
 * DOM: 支配性, STR: 策略性, COM: 社群性, SOL: 独处性
 * AGI: 敏捷性, SEC: 安全性, AES: 美学性
 */
export const animalScoreMap = [
  { A: { AES: 2 }, B: { COM: 2 }, C: { SOL: 2 }, D: { AGI: 2 } },
  { A: { COM: 2 }, B: { SEC: 2 }, C: { AES: 2 }, D: { STR: 2 } },
  { A: { STR: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { DOM: 2 } },
  { A: { STR: 2 }, B: { AGI: 2 }, C: { DOM: 2 }, D: { SOL: 2 } },
  { A: { SOL: 2 }, B: { AGI: 2 }, C: { DOM: 2 }, D: { SEC: 2 } },
  { A: { AES: 2 }, B: { DOM: 2 }, C: { STR: 2 }, D: { COM: 2 } },
  { A: { SOL: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { AES: 2 } },
  { A: { SEC: 2 }, B: { COM: 2 }, C: { SOL: 2 }, D: { DOM: 2 } },
  { A: { COM: 2 }, B: { SEC: 2 }, C: { STR: 2 }, D: { AGI: 2 } },
  { A: { DOM: 2 }, B: { STR: 2 }, C: { AES: 2 }, D: { SEC: 2 } },
  { A: { STR: 2 }, B: { AES: 2 }, C: { DOM: 2 }, D: { AES: 2 } },
  { A: { AES: 2 }, B: { DOM: 2 }, C: { SOL: 2 }, D: { SEC: 2 } },
  { A: { AES: 2 }, B: { DOM: 2 }, C: { AES: 2 }, D: { SOL: 2 } },
  { A: { AES: 2 }, B: { COM: 2 }, C: { STR: 2 }, D: { SEC: 2 } },
  { A: { SOL: 2 }, B: { STR: 2 }, C: { COM: 2 }, D: { AGI: 2 } },
  { A: { DOM: 2 }, B: { COM: 2 }, C: { SOL: 2 }, D: { AGI: 2 } },
  { A: { DOM: 2 }, B: { SEC: 2 }, C: { AGI: 2 }, D: { SOL: 2 } },
  { A: { STR: 2 }, B: { AGI: 2 }, C: { SOL: 2 }, D: { DOM: 2 } },
  { A: { STR: 2 }, B: { DOM: 2 }, C: { COM: 2 }, D: { SOL: 2 } },
  { A: { SOL: 2 }, B: { DOM: 2 }, C: { AES: 2 }, D: { COM: 2 } },
  { A: { SOL: 2 }, B: { DOM: 2 }, C: { SEC: 2 }, D: { COM: 2 } },
  { A: { DOM: 2 }, B: { SOL: 2 }, C: { COM: 2 }, D: { STR: 2 } },
  { A: { AGI: 2 }, B: { COM: 2 }, C: { AES: 2 }, D: { SOL: 2 } },
  { A: { SEC: 2 }, B: { AGI: 2 }, C: { SOL: 2 }, D: { DOM: 2 } },
  { A: { AES: 2 }, B: { COM: 2 }, C: { SOL: 2 }, D: { DOM: 2 } },
  { A: { AES: 2 }, B: { COM: 2 }, C: { DOM: 2 }, D: { STR: 2 } },
  { A: { DOM: 2 }, B: { AGI: 2 }, C: { SEC: 2 }, D: { COM: 2 } },
  { A: { STR: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { DOM: 2 } },
  { A: { SOL: 2 }, B: { COM: 2 }, C: { AES: 2 }, D: { DOM: 2 } },
  { A: { AES: 2 }, B: { COM: 2 }, C: { DOM: 2 }, D: { STR: 2 } },
  { A: { STR: 2 }, B: { DOM: 2 }, C: { AGI: 2 }, D: { COM: 2 } },
  { A: { SOL: 2 }, B: { COM: 2 }, C: { AGI: 2 }, D: { STR: 2 } },
  { A: { DOM: 2 }, B: { AES: 2 }, C: { AGI: 2 }, D: { STR: 2 } },
  { A: { DOM: 2 }, B: { COM: 2 }, C: { AGI: 2 }, D: { STR: 2 } },
  { A: { STR: 2 }, B: { COM: 2 }, C: { AGI: 2 }, D: { SEC: 2 } },
  { A: { DOM: 2 }, B: { AGI: 2 }, C: { SOL: 2 }, D: { SEC: 2 } },
  { A: { DOM: 2 }, B: { STR: 2 }, C: { SEC: 2 }, D: { AES: 2 } },
  { A: { SOL: 2 }, B: { DOM: 2 }, C: { COM: 2 }, D: { AES: 2 } },
  { A: { STR: 2 }, B: { COM: 2 }, C: { AES: 2 }, D: { DOM: 2 } },
  { A: { STR: 2 }, B: { SEC: 2 }, C: { AGI: 2 }, D: { DOM: 2 } },
  { A: { STR: 2 }, B: { DOM: 2 }, C: { SEC: 2 }, D: { AGI: 2 } },
  { A: { SOL: 2 }, B: { DOM: 2 }, C: { COM: 2 }, D: { STR: 2 } },
  { A: { STR: 2 }, B: { DOM: 2 }, C: { COM: 2 }, D: { AES: 2 } },
  { A: { DOM: 2 }, B: { SEC: 2 }, C: { AES: 2 }, D: { SOL: 2 } },
  { A: { DOM: 2 }, B: { STR: 2 }, C: { COM: 2 }, D: { AGI: 2 } },
  { A: { DOM: 2 }, B: { AES: 2 }, C: { STR: 2 }, D: { SOL: 2 } },
  { A: { DOM: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { AGI: 2 } },
  { A: { STR: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { DOM: 2 } },
  { A: { AES: 2 }, B: { DOM: 2 }, C: { SEC: 2 }, D: { SOL: 2 } },
  { A: { STR: 2 }, B: { AES: 2 }, C: { COM: 2 }, D: { SOL: 2 } },
  { A: { DOM: 2 }, B: { AES: 2 }, C: { COM: 2 }, D: { SEC: 2 } },
  { A: { AGI: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { STR: 2 } },
  { A: { STR: 2 }, B: { DOM: 2 }, C: { AES: 2 }, D: { COM: 2 } },
  { A: { STR: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { DOM: 2 } },
  { A: { AGI: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { DOM: 2 } },
  { A: { SOL: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { AES: 2 } },
  { A: { STR: 2 }, B: { COM: 2 }, C: { AGI: 2 }, D: { SOL: 2 } },
  { A: { AGI: 2 }, B: { DOM: 2 }, C: { STR: 2 }, D: { AES: 2 } },
  { A: { STR: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { SOL: 2 } },
  { A: { AES: 2 }, B: { COM: 2 }, C: { SEC: 2 }, D: { DOM: 2 } }
];

/**
 * 维度定义
 */
export const dimensions = {
  DOM: { name: "支配性", description: "领导力、控制欲、统御能力" },
  STR: { name: "策略性", description: "智慧、谋略、解决问题的能力" },
  COM: { name: "社群性", description: "社交能力、团队合作、归属感" },
  SOL: { name: "独处性", description: "独立性、享受独处、自我满足" },
  AGI: { name: "敏捷性", description: "灵活性、适应性、反应速度" },
  SEC: { name: "安全性", description: "安全感需求、稳定性、警惕性" },
  AES: { name: "美学性", description: "对美的追求、优雅、理想主义" }
};

/**
 * 维度代码数组（用于遍历）
 */
export const dimensionKeys = ["DOM", "STR", "COM", "SOL", "AGI", "SEC", "AES"];

